import React from 'react';
import PropTypes from 'prop-types';

function ContactInfo({ reporter, smallMode }) {
  const liClasses = 'list-group-item auto-truncate text-nowrap';
  const hasContactInfo = reporter.email || reporter.twitter || reporter.phone || reporter.location_string;

  if (!hasContactInfo) return null;

  return (
    <>
      <ul
        className="list-group list-group-borderless list-group-xs"
        style={{ fontSize: smallMode ? '75%' : '85%' }}
      >
        {reporter.twitter && (
          <li className={liClasses}>
            <a
              href={`https://twitter.com/${reporter.twitter}`}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-brands fa-x-twitter me-1" />
              {reporter.twitter}
            </a>
          </li>
        )}
        {reporter.phone && (
          <li className={liClasses}>
            <a href={`tel:${reporter.phone}`}>
              <i className="fa-solid fa-phone me-1" />
              {reporter.phone}
            </a>
          </li>
        )}
        {reporter.location_string && (
          <li className={liClasses}>
            <a
              href={`https://www.google.com/maps?q=${reporter.location_string}`}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-solid fa-location-dot me-1" />
              {reporter.location_string}
            </a>
          </li>
        )}
      </ul>
      <div className="clearfix mb-2" />
    </>
  );
}

ContactInfo.propTypes = {
  reporter: PropTypes.instanceOf(Object).isRequired,
  smallMode: PropTypes.bool,
};

ContactInfo.defaultProps = {
  smallMode: false,
};

export default ContactInfo;
